import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { ChargesFormType } from '../../hooks';

type Params = {
  index: number;
  currentLetter?: string;
  isOrderTypeNotHUD1: boolean;
};

export const useChargeFieldSync = ({ index, currentLetter, isOrderTypeNotHUD1 }: Params) => {
  const { setValue, getValues } = useFormContext<ChargesFormType>();

  const handleAmountFieldChange = useCallback(
    (newAmount: number | null) => {
      setValue(`charges.${index}.buyer_at`, 0, { shouldDirty: true });
      setValue(`charges.${index}.buyer_before`, 0, { shouldDirty: true });
      setValue(`charges.${index}.seller_at`, 0, { shouldDirty: true });
      setValue(`charges.${index}.seller_before`, 0, { shouldDirty: true });
      setValue(`charges.${index}.by_others`, 0, { shouldDirty: true });

      if (currentLetter === 'G' && newAmount !== null) {
        let perMonth: number = 0;
        const numberOfMonths = getValues(`charges.${index}.months`);

        if (newAmount !== 0 && numberOfMonths) {
          perMonth = newAmount / numberOfMonths;
        }
        setValue(`charges.${index}.per_month`, perMonth, { shouldDirty: true });
      }
    },
    [index, setValue, currentLetter, getValues]
  );

  const handlePaidByAmountChange = useCallback(() => {
    let newAmount =
      getValues(`charges.${index}.buyer_at`) +
      getValues(`charges.${index}.seller_at`) +
      getValues(`charges.${index}.by_others`);

    if (isOrderTypeNotHUD1) {
      newAmount =
        newAmount +
        getValues(`charges.${index}.buyer_before`) +
        getValues(`charges.${index}.seller_before`);
    }

    setValue(`charges.${index}.amount`, newAmount, { shouldDirty: false });

    if (currentLetter === 'G') {
      let perMonth: number = 0;
      const numberOfMonths = getValues(`charges.${index}.months`);

      if (newAmount !== 0 && numberOfMonths) {
        perMonth = newAmount / numberOfMonths;
      }
      setValue(`charges.${index}.per_month`, perMonth, { shouldDirty: true });
    }
  }, [index, setValue, getValues, isOrderTypeNotHUD1, currentLetter]);

  const handleNumberOfMontsFieldChange = useCallback(
    (newMonths: number) => {
      if (currentLetter === 'G') {
        const currentAmount = getValues(`charges.${index}.amount`);

        let newPerMonth: number = 0;
        let newBuyerAtAmount: number = 0;

        if (newMonths !== 0 && currentAmount !== 0) {
          newPerMonth = currentAmount / newMonths;
          newBuyerAtAmount = newPerMonth * newMonths;
        }

        setValue(`charges.${index}.per_month`, newPerMonth, { shouldDirty: true });
        setValue(`charges.${index}.buyer_at`, newBuyerAtAmount, { shouldDirty: true });
      }
    },
    [index, setValue, currentLetter, getValues]
  );

  const handlePerMonthAmountFieldChange = useCallback(
    (newPerMonth: number) => {
      if (currentLetter === 'G') {
        let newAmount: number = newPerMonth;
        const currentNumberOfMonths = getValues(`charges.${index}.months`);

        if (currentNumberOfMonths && currentNumberOfMonths !== 0) {
          newAmount = newPerMonth * currentNumberOfMonths;
        }

        setValue(`charges.${index}.amount`, newAmount, { shouldDirty: true });
      }
    },
    [index, setValue, currentLetter, getValues]
  );

  return {
    handleAmountFieldChange,
    handlePaidByAmountChange,
    handleNumberOfMontsFieldChange,
    handlePerMonthAmountFieldChange,
  };
};
